import CommonLookupDisplay from "components/CommonLookupDisplay";
import { GlobalContext } from "components/GlobalContext";
import { createFilterableArrayColumnDefinition, IColumnDefinition } from "components/SortableTable";
import IProduct, { IProductCreateOrUpdate, IProductFilters, IProductInitResult } from "models/sql/IProduct";
import { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ProductService from "services/ProductService";

interface IProductsLookupProps {
    baseData?: IProductInitResult;
}

const ProductsLookup = (props: IProductsLookupProps) => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const navigate = useNavigate();
    const [filter, setFilter] = useState<IProductFilters>({});

    const getColumns = (): IColumnDefinition<IProduct, IProductFilters>[] => {
        return [
            createFilterableArrayColumnDefinition<IProduct, IProductFilters>(
                globalContext,
                "name",
                "names",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`name${row.productId}`}>
                    {
                        (row.name || "").split(",")
                            .map(
                                (e, index, array) => <>{e}{array.length > 1 && <br></br>}</>)
                    }</td>),
            createFilterableArrayColumnDefinition<IProduct, IProductFilters>(
                globalContext,
                "partNumber",
                "partNumbers",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`partNumber${row.productId}`}>
                    {
                        (row.partNumber || "").split(",")
                            .map(
                                (e, index, array) => <>{e}{array.length > 1 && <br></br>}</>)
                    }</td>),
            createFilterableArrayColumnDefinition<IProduct, IProductFilters>(
                globalContext,
                "serialPrefix",
                "serialPrefixs",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`serialPrefix${row.productId}`}>
                    {
                        (row.serialPrefix || "").split(",")
                            .map(
                                (e, index, array) => <>{e}{array.length > 1 && <br></br>}</>)
                    }</td>),
            {
                propName: "listPrice",
                title: "List Price",
                customRenderer: (value, data) => <td className="align-top" key={`listPrice${data.productId}`}>
                    {data.listPrice || 0}
                </td>,
                sortable: true
            },
            {
                propName: "publish",
                title: "Active",
                customRenderer: (value, data) => <td className="align-top" key={`publish${data.productId}`}>
                    {data.publish ? "Yes" : "No"}
                </td>,
                sortable: true
            }
        ];
    };

    const rowStyleRenderer = (row: IProduct): React.CSSProperties => {
        return !row.publish ? { backgroundColor: "rgba(255, 0, 0, 0.1)" } : {};
    };

    const getTools = () => [
        <>
            {
                globalContext.roles.some(r => r === "Web.Admin") &&
                <Button
                    key="createnew"
                    variant="success"
                    className="full-sm"
                    onClick={() => { navigate(`/Products/Detail/`) }}>Create New</Button>
            }
        </>
    ];

    return (
        <CommonLookupDisplay<IProductFilters, IProduct, IProductCreateOrUpdate>
            baseFilters={{
                sortBys: ["ProductId"],
                sortDescending: true
            }}
            filterHints={{
                productIds: "Array",
                names: "Array",
                partNumbers: "Array",
                serialPrefixs: "Array",
                sortBys: "Array",
                sortDescending: "Boolean"
            }}
            dataTypeName="Product"
            dataTypeNamePlural="Products"
            pathName="Products"
            primaryIdKey="productId"
            className=""
            countriesFilterKey=""
            statesFilterKey=""
            filter={filter}
            setFilter={setFilter}
            columnDefinitions={getColumns()}
            service={ProductService}
            tools={getTools()}
            rowStyleRenderer={rowStyleRenderer}
        />
    );
}

export default ProductsLookup;
